import WordProjections from './WordProjections'

export default WordProjections
